import { Button, Space, Typography, Form, InputNumber, Input, Select } from 'antd'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faDesktop, faPlus, faX } from '@fortawesome/pro-solid-svg-icons'
import { AdminEmployeesStepProps } from '../../types'
import { PAY_TYPE_OPTIONS, MAX_ENTITIES } from '../../constants'
import { checkField } from '../../inputSanityModel'
import BandSliderInput from '../BandSliderInput'
import { SLIDER_TRACKS } from '../../bandSliderModel'
import './StepFieldRow.css'

const { Title, Paragraph } = Typography

export const AdminEmployeesStep = ({
  data,
  onCountChange,
  onEmployeeUpdate,
  onEmployeeAdd,
  onEmployeeRemove, crossInputCard }: AdminEmployeesStepProps) => {
  return (
    <Space
      direction="vertical"
      size="large"
      style={{
        width: '100%',
        maxWidth: '1200px',
        padding: '40px 20px'
      }}
    >
      <div style={{
        backgroundColor: 'white',
        padding: '32px',
        borderRadius: '8px',
        boxShadow: '0 2px 8px rgba(0,0,0,0.1)'
      }}>
        <Space direction="horizontal" size="middle" style={{ marginBottom: '16px' }}>
          <FontAwesomeIcon icon={faDesktop} style={{ fontSize: '24px', color: '#ff6b4a' }} />
          <Title level={3} style={{ margin: 0 }}>Admin Employees</Title>
        </Space>

        <Paragraph style={{ color: '#666', marginBottom: '32px' }}>
          Add administrative and back office employees.
        </Paragraph>

        {crossInputCard}

        <Form layout="vertical">
          <Space direction="vertical" size="large" style={{ width: '100%' }}>
            <Form.Item
              label="How many back office or admin employees do you have?"
              required
              style={{ marginBottom: 0 }}
              help="Number of back office/administrative employees that do NOT include the business owner"
            >
              <InputNumber
                value={data.employeeCount}
                onChange={(value) => onCountChange(value || 0)}
                min={0}
                max={MAX_ENTITIES}
                style={{ width: '100%' }}
                size="large"
              />
            </Form.Item>

            {data.employees.map((employee, index) => (
              <div
                key={index}
                style={{
                  border: '1px solid #d9d9d9',
                  borderRadius: '8px',
                  padding: '24px',
                  position: 'relative'
                }}
              >
                <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '24px' }}>
                  <Title level={5} style={{ margin: 0 }}>Admin Employee #{index + 1}</Title>
                  <Button
                    type="text"
                    icon={<FontAwesomeIcon icon={faX} />}
                    onClick={() => onEmployeeRemove(index)}
                    style={{ color: '#999' }}
                  />
                </div>

                <Space className="step-field-row" direction="horizontal" size="large" style={{ width: '100%', alignItems: 'flex-start' }}>
                  <Form.Item
                    label="Name"
                    required
                    style={{ flex: 1, marginBottom: 0 }}
                  >
                    <Input
                      value={employee.name}
                      onChange={(e) => onEmployeeUpdate(index, 'name', e.target.value)}
                      size="large"
                      placeholder="Employee name"
                    />
                  </Form.Item>

                  <Form.Item
                    label="Pay Type"
                    required
                    style={{ flex: 1, marginBottom: 0 }}
                  >
                    <Select
                      value={employee.payType}
                      onChange={(value) => onEmployeeUpdate(index, 'payType', value)}
                      options={PAY_TYPE_OPTIONS}
                      size="large"
                    />
                  </Form.Item>

                  {employee.payType === 'Salary' ? (
                    <Form.Item
                      label="Annual Salary ($)"
                      required
                      style={{ flex: 1, marginBottom: 0 }}
                    >
                      <BandSliderInput
                        value={employee.annualSalary}
                        onChange={(value) => onEmployeeUpdate(index, 'annualSalary', value)}
                        track={SLIDER_TRACKS.workerPaySalary}
                        unit="dollar"
                        placeholder="47,958"
                        compact
                      />
                    </Form.Item>
                  ) : (
                    <>
                      <Form.Item
                        label="Hourly Rate ($)"
                        required
                        style={{ flex: 1, marginBottom: 0 }}
                      >
                        <BandSliderInput
                          value={employee.hourlyRate}
                          onChange={(value) => onEmployeeUpdate(index, 'hourlyRate', value)}
                          track={SLIDER_TRACKS.workerPayHourly}
                          formatValue={(amount) => `$${amount.toFixed(2)}`}
                          placeholder="18.50"
                          compact
                          warning={checkField('adminWorkerPay', employee.hourlyRate)}
                          warnOnTrack
                        />
                      </Form.Item>

                      <Form.Item
                        label="Hours / Week"
                        required
                        style={{ flex: 1, marginBottom: 0 }}
                      >
                        <BandSliderInput
                          value={employee.hoursPerWeek}
                          onChange={(value) => onEmployeeUpdate(index, 'hoursPerWeek', value)}
                          track={SLIDER_TRACKS.crewHoursPerWeek}
                          unit="number"
                          placeholder="40"
                          compact
                          warning={checkField('workerHoursPerWeek', employee.hoursPerWeek)}
                          warnOnTrack
                        />
                      </Form.Item>
                    </>
                  )}
                </Space>
              </div>
            ))}

            <Button
              size="large"
              onClick={onEmployeeAdd}
              icon={<FontAwesomeIcon icon={faPlus} />}
              style={{ width: '100%' }}
              disabled={data.employees.length >= MAX_ENTITIES}
            >
              Add Another Employee
            </Button>
          </Space>
        </Form>
      </div>
    </Space>
  )
}
